import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  create(inscripcionId, datos) {
    return axiosIns.post(
      obtenerUrlAPIComisiones(`inscripciones-documentos-personas/crear/inscripciones/${inscripcionId}`),
      datos,
    );
  },
  async createMany(inscripcionId, datos) {
    return await axiosIns.post(
      obtenerUrlAPIComisiones(`inscripciones-documentos-personas/inscripciones/${inscripcionId}`),
      datos,
    );
  },
  async findByInscripcion(inscripcionId) {
    return await axiosIns.get(
      obtenerUrlAPIComisiones(`inscripciones-documentos-personas/inscripciones/${inscripcionId}`),
    );
  },
  async vincularDocumentoPersonaAInscripcion(datos) {
    return await axiosIns.post(obtenerUrlAPIComisiones('inscripciones-documentos-personas/vincular'), datos);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('inscripciones-documentos-personas'), opciones);
  },
  async findAllAgrupado(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('inscripciones-documentos-personas/agrupado'), opciones);
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`inscripciones-documentos-personas/${id}`));
  },
  async reemplazarDocumentoPersona(inscripcionId, datos) {
    return await axiosIns.post(
      obtenerUrlAPIComisiones(`inscripciones-documentos-personas/reemplazar/inscripciones/${inscripcionId}`),
      datos,
    );
  },
  async documentosPorProgramaId(programaId, opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIComisiones(`inscripciones-documentos-personas/documentos-por-programa/${programaId}`),
      opciones,
    );
  },
};
